import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { content } from '../data/content';
import type { Lang, Variant } from '../App';

export function Navbar({ lang, setLang, variant, setVariant }: { lang: Lang; setLang: (l: Lang) => void; variant: Variant; setVariant: (v: Variant) => void }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const t = content[lang].nav;
  useEffect(() => { const h = () => setScrolled(window.scrollY > 50); window.addEventListener('scroll', h); return () => window.removeEventListener('scroll', h); }, []);
  const links = [{ href: '#about', label: t.about },{ href: '#experience', label: t.experience },{ href: '#skills', label: t.skills },{ href: '#projects', label: t.projects },{ href: '#education', label: t.education },{ href: '#contact', label: t.contact }];
  const variantLabel = (v: Variant) => v === 'security' ? (lang === 'en' ? 'Security' : 'Seguridad') : (lang === 'en' ? 'Game Tech' : 'Game Tech');
  const otherVariant: Variant = variant === 'security' ? 'game' : 'security';
  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="#hero" className="nav-logo">Jordan Rivera R<span className="accent">.</span></a>
        <div className="nav-links desktop-only">
          {links.map(l => <a key={l.href} href={l.href}>{l.label}</a>)}
          <span className="status-badge"><span className="status-dot" />{lang === 'en' ? 'Available' : 'Disponible'}</span>
          <button className="variant-toggle" onClick={() => setVariant(otherVariant)} title={lang === 'en' ? `Switch to ${variantLabel(otherVariant)} CV` : `Cambiar a CV ${variantLabel(otherVariant)}`}>
            <span className={`variant-dot ${variant === 'security' ? 'sec' : 'game'}`} />
            {variantLabel(variant)}
          </button>
          <button className="lang-toggle" onClick={() => setLang(lang === 'en' ? 'es' : 'en')}>{lang === 'en' ? 'ES' : 'EN'}</button>
        </div>
        <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
      </div>
      <AnimatePresence>{menuOpen && (
        <motion.div className="mobile-menu" initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }} transition={{ type: 'spring', damping: 25, stiffness: 200 }}>
          <button className="mobile-close" onClick={() => setMenuOpen(false)}>✕</button>
          <span className="status-badge"><span className="status-dot" />{lang === 'en' ? 'Available for Work' : 'Disponible'}</span>
          {links.map((l, i) => <motion.a key={l.href} href={l.href} onClick={() => setMenuOpen(false)} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }} className="mobile-link">{l.label}</motion.a>)}
          <button className="variant-toggle" onClick={() => { setVariant(otherVariant); setMenuOpen(false); }}>
            <span className={`variant-dot ${variant === 'security' ? 'sec' : 'game'}`} />
            {variantLabel(variant)} → {variantLabel(otherVariant)}
          </button>
          <button className="lang-toggle" onClick={() => { setLang(lang === 'en' ? 'es' : 'en'); setMenuOpen(false); }}>{lang === 'en' ? 'Español' : 'English'}</button>
        </motion.div>
      )}</AnimatePresence>
    </nav>
  );
}
